import React, { Component } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  Paper,
  TextField,
  InputAdornment,
  Button,
  Link
} from '@material-ui/core';
import Search from '@material-ui/icons/Search';
import TableCell from 'components/Table/TableCell';
import { observer, inject } from 'mobx-react';
import componentStyles from 'components/Table/Table.css';
import { get } from 'lodash';

@inject('customerCaseStore')
@inject('languageStore')
@observer
class FrontPageTable extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.props.customerCaseStore.fetchCustomerCases(event.target.value);
  }

  fieldValue(o, path) {
    let translation = o.translations.find(translation => translation.lang === this.props.languageStore.language)
                      || o.translations[0];

    let val = get(translation, path);

    if (Array.isArray(val)) {
      return val.join(', ');
    } else {
      return val;
    }
  }

  render() {
    return (
      <Paper style={componentStyles.root}>
        <TextField
          id="search"
          label="Hae"
          type="search"
          margin="normal"
          onChange={event => {
            this.handleChange(event);
          }}
          style={{ marginLeft: 20, marginBottom: 20 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            )
          }}
        />
        <Table style={componentStyles.table}>
          <TableHead>
            <TableRow>
              {/* Create Table Head Row with col names */}
              {this.props.tableCols.map(n => {
                return <TableCell key={n.name} cellContent={n.name} />;
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.data.map(n => {
              return (
                <TableRow key={n._id}>
                {
                  this.props.tableCols.map((col, index) => {
                    let value = this.fieldValue(n, col.value)

                    if (index === 0) {
                      return (
                        <TableCell
                          component="th"
                          scope="row"
                          cellContent={
                            <Link
                              color="primary"
                              variant="raised"
                              to={`${this.props.linkRoute}${n._id}`}
                              component={RouterLink}
                            >
                              {value}
                            </Link>
                          }
                        />
                      )
                    } else {
                      return <TableCell cellContent={value} />
                    }
                  })
                }
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}

export default FrontPageTable;



// WEBPACK FOOTER //
// ./src/views/MainPage/Table/Table.jsx